/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1OrganizationMemberEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_ORGANIZATION_MEMBER_EVENT_ENTITY_NAME = 'ixm.userauth.v1.OrganizationMemberEvent';
export const ixmUserauthV1OrganizationMemberEventEntity = new schema.Entity<IxmUserauthV1OrganizationMemberEvent>(IXM_USERAUTH_V1_ORGANIZATION_MEMBER_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmUserauthV1OrganizationMemberEvent) => `${entity.metadata?.eventId}` });

